const LabelMapper = {
  total: 'Total',
  revenue: 'Revenue',
  ratesAndAnnualCharges: 'Rates and Annual Charges',
  userChargesAndFees: 'User Charges and Fees',
  interestAndInvestmentRevenue: 'Interest and Investment Revenue',
  otherRevenue: 'Other Revenue',
  grantsAndContributionsProvidedForOperating:
    'Grants and Contributions Provided for Operating Purposes',
  grantsAndContributionsProvidedForCapital:
    'Grants and Contributions Provided for Capital Purposes',
  netGainsFromTheDisposalsOfAssets: 'Net Gains from the Disposal of Assets',
  NetShareOfInterestsInJointVenturesAndAssociates:
    'Net Share of Interests in Joint Ventures and Associates',
  expenses: 'Expenses',
  employeeBenefitsAndOnCosts: 'Employee Benefits and on Costs',
  borrowingCosts: 'Borrowing Costs',
  materialsAndContracts: 'Materials and Contracts',
  depreciationAndAmortisation: 'Depreciation and Amortisation',
  impairment: 'Impairment',
  otherExpenses: 'Other Expenses',
  netLossesFromDisposalOfAssets: 'Net Losses from Disposal of Assets',
  operatingResult: 'Operating Result',
  assets: 'Assets',
  currentAssets: 'Current Assets',
  nonCurrentAssets: 'Non Current Assets',
  miscellaneousNonCurrentAssets: 'Miscellaneous non Current Assets',
  liabilities: 'Liabilities',
  currentLiabilities: 'Current Liabilities',
  nonCurrentLiabilities: 'Non Current Liabilities',
  miscellaneousCurrentLiabilities: 'Miscellaneous Current Liabilities',
  miscellaneousNonCurrentLiabilities: 'Miscellaneous non Current Liabilities',
  operatingPerformance: 'Operating Performance',
  ownSourceOperatingRevenue: 'Own Source Operating Revenue',
  unrestrictedCurrentRatio: 'Unrestricted Current Ratio',
  debtServiceCoverRatio: 'Debt Service Cover Ratio',
  ratesAndAnnualChargesOutstandingPercentage:
    'Rates and Annual Charges Outstanding Percentage',
  cashExpenseCoverRatio: 'Cash Expense Cover Ratio',
  ordinaryRates: 'Ordinary Rates',
  specialRates: 'Special Rates',
  annualCharges: 'Annual Charges',
  specificUserCharges: 'Specific User Charges',
  statutoryAndRegulatoryCharges: 'Statutory and Regulatory Charges',
  otherCharges: 'Other Charges',
  cashAndCashEquivalents: 'Cash and Cash Equivalents',
  currentInvestments: 'Current Investments',
  currentReceivables: 'Current Receivables',
  currentInventories: 'Current Inventories',
  otherCurrentAssets: 'Other Current Assets',
  nonCurrentAssetsHeldForSale: 'Non Current Assets Held for Sale',
  nonCurrentInvestments: 'Non Current Investments',
  nonCurrentReceivables: 'Non Current Receivables',
  nonCurrentInventories: 'Non Current Inventories',
  infrastructurePropertyPlantAndEquipment:
    'Infrastructure Property Plant and Equipment',
  investmentsAccountedForUsingTheEquityMethod:
    'Investments Accounted for using the Equity method',
  investmentProperty: 'Investment Property',
  intangibleAssets: 'Intangible Assets',
  currentPayables: 'Current Payables',
  currentBorrowings: 'Current Borrowings',
  currentProvisions: 'Current Provisions',
  incomeReceivedInAdvance: 'Income Received in Advance',
  nonCurrentPayables: 'Non Current Payables',
  nonCurrentBorrowings: 'Non Current Borrowings',
  nonCurrentProvisions: 'Non Current Provisions',
  // New for qld
  otherRevenues: 'Other Revenues',
  capitalExpenses: 'Capital Expenses',
  infrastructurePropertyPlantEquipment:
    'Infrastructure Property Plant Equipment',
  operatingSurplusRatio: 'Operating Surplus Ratio',
  grantsContributionsProvidedForOperating:
    'Grants Contributions Provided For Operating',
  averageOsr: 'Average Operating Surplus Ratio',
  grantsContributionsProvidedForCapital:
    'Grants Contributions Provided For Capital',
  miscellaneous: 'Miscellaneous',
  netFinancialLiabilities: 'Net Financial Liabilities',
  assetSustainabilityRatio: 'Asset Sustainability Ratio',
  averageAsr: 'Average Asset Sustainability Ratio',
  relativeRiskAssessment: 'Relative Risk Assessment',
  averageRemainingUsefulLifeOfInfrastructureAssets:
    'Average Remaining useful life of infrastructure assets',
  _trend: 'Should not be displayed',
  // new for health
  healthServiceFunding: 'Health Service Funding',
  grantsAndOtherContributions: 'Grants And Other Contributions',
  gainOnDisposalRevaluationOfAssets: 'Gain on disposal/revaluation of assets',
  employeeExpenses: 'Employee Expenses',
  suppliesAndServices: 'Supplies And Services',
  operatingCashOutflows: 'Operating Cash Outflows',
  grants: 'Grants',
  currentEmployeeProvision: 'Current Employee Provision',
  depreciationAndAmmortization: 'Depreciation And Ammortization',
  impairmentLoss: 'Impairment Loss',
  unrestrictedCash: 'Unrestricted Cash',
  restrictedCash: 'Restricted Cash',
  interestExpense: 'Interest Expense',
  provisions: 'Provisions',
  unearnedRevenue: 'Unearned Revenue',
  cashAvailableDays: 'Cash Available Days',
  retainedSurplusExpenditure: 'Retained Surplus/Expenditure',
  frontlineStaff: 'Frontline Staff',
  nonFrontLineStaff: 'Non Frontline Staff',
  qwau: 'QWAU',
  anticipatedMaintenance: `Anticipated Maintenance`,
  activityBasedFuningAbf: 'Activity Based Funding (ABF)',

  // New for education
  commonwealthGovernmentFinancialAssistance:
    'Commonwealth Government Financial Assistance',
  hecsHelpStudentPayments: 'HECS/HELP Student Payments',
  feesAndCharges: 'Fees and Charges',
  investmentRevenue: 'Investment Revenue',
  royaltiesTrademarksAndLicences: 'Royalties, Trademarks and Licences',
  consultanciesAndContracts: 'Consultancies and Contracts',
  stateAndLocalGovernmentFinancialAssistance:
    'State and Local Government Financial Assistance',
  otherIncome: 'Other Income',
  investmentIncome: 'Investment Income',
  profitLossOnInvestmentsAccountedForUsingTheEquityMethod:
    'Profit/Loss on Investments Accounted For Using the Equity Method',
  employeeRelatedExpenses: 'Employee Related Expenses',
  repairsAndMaintenance: 'Repairs and Maintenance',
  financeBorrowingCosts: 'Finance Borrowing Costs',
  impairmentOfAssets: 'Impairment of Assets',
  shareOfLossOnInvestmentsAccountedForUsingTheEquityMethod:
    'Share of Loss on Investments Accounted For Using the Equity Method',
  lossOnDisposalOfAssets: 'Loss on Disposal of Assets',
  incomeTaxExpense: 'Income Tax Expenses',
  currentTradeAndOtherReceivables: 'Current Trade and Other Receivables',
  currentContractAssets: 'Current Contract Assets',
  inventories: 'Inventories',
  otherFinancialAssets: 'Other Financial Assets',
  otherNonFinancialAssets: 'Other Non-Financial Assets',
  propertyPlantAndEquipment: 'Property Plant and Equipment',
  nonCurrentTradeAndOtherReceivables: 'Non-Current Trade and Other Receivables',
  investmentsAccountedForUsingEquityMethod:
    'Investments Accounted For Using the Equity Method',
  nonCurrentOtherFinancialAssets: 'Other Non-Current Financial Assets',
  otherNonCurrentAssets: 'Other Non-Current Assets',
  currentContractLiabilities: 'Current Contract Liabilities',
  currentLeaseLiabilities: 'Current Lease Liabilities',
  otherLiabilities: 'Other Liabilities',
  currentTradeAndOtherPayables: 'Current Trade and Other Payables',
  nonCurrentTradeAndOtherPayables: 'Non Current Trade And Other Payables',
  nonCurrentContractLiabilities: 'Non Current Contract Liabilities',
  nonCurrentLeaseLiabilities: 'Non Current Lease Liabilities',
  nonCurrentOtherLiabilities: 'Other Non Current Liabilities',
  ppEAdditions: 'PP&E Additions',
  staffFtEs: 'Staff (FTEs)',
  year2019StudentNumbersEftsl: '2019 Student Numbers (EFTSL)',
  year2019StudentStaffRatioEftslFte: '2019 Student-Staff Ratio (EFTSL/FTE)',
  employeeExpensePerFte: 'Employee Expense Per FTE',
  unisDomesticStudents: 'Domestic Students (EFTSL)',
  unisInternationalStudents: 'International Students (EFTSL)',
  numberOfSchoolsCampusesInQld: 'Number of Schools/Campuses in QLD',
  numberOfSchoolsCampusesOutsideQld: 'Number of Schools/Campuses Outside QLD',
  tuitionAndBoardingFees: 'Tuition and Boarding Fees',
  donations: 'Donations',
  interestInvestmentIncome: 'Interest / Investment Income',
  userCharges: 'User Charges',
  increaseDecreaseInAssetRevaluationSurplus:
    'Increase/(Decrease) in Asset Revaluation Surplus',
  receivables: 'Receivables',
  rightOfUseAssets: 'Right-of-use Assets',
  payables: 'Payables',
  leaseLiabilities: 'Lease Liabilities',
  financialLiabilities: 'Financial Liabilities',
  accruedEmployeeBenefits: 'Accrued Employee Benefits',
  appropriationRevenue: 'Appropriation Revenue',
  interest: 'Interest',
  salesOfGoodsAndServices: 'Sales of Goods and Services',
  shareOfProfitsOfJointVenturesAccountedForUsingTheEquityMethod:
    'Share of Profits of Joint Ventures Accounted For Using the Equity Method',
  impairmentLosses: 'Impairment Losses',
  grantsAndSubsidies: 'Grants and Subsidies',
  lossesOnDisposalRemeasurementOfAssets:
    'Losses On Disposal/Remeasurement of Assets',
  revaluationDecrement: 'Revaluation Decrement',
  incomeTaxExpenses: 'Income Tax Expenses',
  transfersOfAdministeredIncomeToGovernment:
    'Transfers Of Administered Income to Government',
  prepayments: 'Prepayments',
  cashAtBank: 'Cash at Bank',
  appropriationReceivable: 'Appropriation Receivable',
  gstInputTaxCreditsReceivable: 'GST Input Tax Credits Receivable',
  tradeReceivableCurrentAssets: 'Trade Receivable',
  interestBearingLiabilities: 'Interest Bearing Liabilities',
  gstPayable: 'GST Payable',
  overdraftFacilities: 'Overdraft Facilities',
  revenuePayableToGovernment: 'Revenue Payable to Government',

  // New for transport
  qtripsNationalNetworkIndicativeTotalProjectsCost:
    'National Network Indicative Projects Cost',
  qtripsStateNetworkIndicativeTotalCost:
    'State Network Indicative Projects Cost',
  qtripsLocalNetworkIndicativeTotalCost:
    'Local Network Indicative Projects Cost',
  lengthOfManagedRoads: 'Length of Managed Roads',
  numberOfBridges: 'Number of Bridges',
  kilometresOfCouncilManagedRoad: 'Council Managed Roads',
  numberOfBridgesCouncilManaged: 'Number of Bridges',
  totalCapitalExpenditureOnRoads: 'Total Capital Expenditure on Roads',
  totalMaintenanceExpenditureOnRoads: 'Total Maintenance Expenditure on Roads',
  writtenDownValueOfRoadsBridgesAndMajorCulvert:
    'Written-down Value of Roads, Bridges and Major Culverts',
  valuationLastPeformed: 'Valuation Last Peformed',
  appropriations: 'Appropriations',
  cash: 'Cash',
  otherAssets: 'Other Assets',
  intangibles: 'Intangibles',
  deferredTaxAssets: 'Deferred Tax Assets',
  currentTaxAssets: 'Current Tax Assets',
  cashAdvanceFacility: 'Cash Advance Facility',
  financeAndBorrowingCosts: 'Finance and Borrowing Costs',
  investmentProperties: 'Investment Properties',
  borrowings: 'Borrowings',
  deferredTaxLiabilities: 'Deferred Tax Liabilities',
  currentTaxLiabilities: 'Current Tax Liabilities',
  accruedEmployeeExpenses: 'Accrued Employee Expenses',
  dividendsProvidedForDuringTheYear: 'Dividends Provided For During The Year',
  keyCommodities: 'Key Commodities',
  numberOfPorts: 'Number of Ports',
  importAndExportTradeThroughput: 'Import and Export Trade Throughput',
  vesselsToPort: 'Vessels To Port',
  vesselIncome: 'Vessel Income',
  employmentFullTimeEquivalents: 'Employment Full Time Equivalents',
  capitalAdditions: 'Capital Additions',
};

export const EntityLabels = Object.keys(LabelMapper).reduce((acc, curr) => {
  return { ...acc, [curr]: curr };
}, {});

const EntityLabelMapper = {
  plural: {
    DOT: 'Department of Transport',
    STATUTORY: 'Statutory Authorities',
    PORT: 'Government owned corporations (Ports)',
    CRRDA: 'Statutory Authority',
    QR: 'Statutory Authority',
  },
  singular: {
    DOT: 'Department of Transport',
    STATUTORY: 'Statutory Authority',
    PORT: 'Government owned corporation (Port)',
    CRRDA: 'Statutory Authority',
    QR: 'Statutory Authority',
  },
};

export const entityLabelMatcher = (str, pluralOrSingular) => {
  const label =
    pluralOrSingular === 'plural'
      ? EntityLabelMapper.plural[str]
      : EntityLabelMapper.singular[str];
  if (!label) {
    throw Error('Missing label for: ' + str);
  }
  return label;
};

export const labelMatcher = (str) => {
  const label = LabelMapper[str];
  if (!label) {
    console.log('Missing label for: ', label);
    return str;
  }
  return label;
};



// WEBPACK FOOTER //
// ./src/helpers/label-mapper.js